__turbopack_context__.v({
  "ad": "ZnARQW_ad",
  "container": "ZnARQW_container",
  "grid": "ZnARQW_grid",
  "rec": "ZnARQW_rec",
  "size--lg": "ZnARQW_size--lg",
  "size--sm": "ZnARQW_size--sm",
  "variant--embedded": "ZnARQW_variant--embedded",
  "variant--images": "ZnARQW_variant--images",
});
